import { gql } from '@apollo/client';

export const ALL_INSTITUTION_USERS_FOR_SELECT_INPUT = gql`
  query AllInstitutionUsersForSelectInput($input: UserFilterInput!) {
    users: allInstitutionPortalUsers(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`;
